export const getUID = (prefix = "id"): string => {
  return `${prefix}_${Math.random().toString(16).slice(2)}`;
};

export const getTodayDate = () => {
  return new Date().toLocaleString("en-US", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });
};

export const getFaDate = (date: string) => {
  return new Date(date).toLocaleString("fa-IR", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const handleRootThemeMode = (mode = "light") => {
  const root = document.getElementsByTagName("html")[0];

  if (mode === "dark") {
    root.classList.add("dark-theme");
  } else {
    root.classList.remove("dark-theme");
  }
};

export const convertNumberToEnglish = (number: any) => {
  if (!number) {
    return "";
  }
  return number.replace(/[۰-۹]/g, (d: any) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
};
